import React from 'react'

import { PlatformAnnouncements, railsCsrfFetch } from '@planningcenter/topbar'

const ApiAnnouncements = ({ platformNotifications, railsEnv: env }) => {
  return (
    <PlatformAnnouncements
      data={platformNotifications}
      env={env}
      configuredFetch={railsCsrfFetch}
    />
  )
}

export default ApiAnnouncements
